import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React, { useCallback, useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { SECTION_DEFS } from "./LeadDrawerRelitixDetails/relitixDetailsConfig";
import { Section } from "./LeadDrawerRelitixDetails/Section";

const LeadDrawerRelitixDetails = ({ lead = null }) => {
  const isOpenLocalStorage = localStorage.isRelitixOpen;
  const [isOpen, setIsOpen] = useState(
    isOpenLocalStorage ? JSON.parse(isOpenLocalStorage) : false,
  );

  const onCollapseClick = useCallback(
    (e) => {
      e.preventDefault();
      const newIsOpen = !isOpen;
      setIsOpen(newIsOpen);
      localStorage.isRelitixOpen = newIsOpen;
    },
    [isOpen],
  );

  const attrs = lead?.relitix_attributes || {};

  return (
    <div>
      <div className="pull-right">
        <button
          type="button"
          className="btn btn-secondary btn-sm mr-1"
          onClick={onCollapseClick}
        >
          {isOpen ? (
            <FontAwesomeIcon icon={["far", "fa-minus"]} />
          ) : (
            <FontAwesomeIcon icon={["far", "fa-plus"]} />
          )}
        </button>
      </div>

      <h4 className="mb15">Relitix</h4>

      <Collapse in={isOpen} mountOnEnter unmountOnExit>
        <div>
          <table className="table table-flush table-sm no-border">
            <tbody>
              {SECTION_DEFS.map((def) => (
                <Section key={def.key} def={def} attrs={attrs} />
              ))}
            </tbody>
          </table>
        </div>
      </Collapse>
    </div>
  );
};

LeadDrawerRelitixDetails.propTypes = {
  lead: PropTypes.shape({}),
};

export default LeadDrawerRelitixDetails;
